module.exports = __webpack_public_path__ + "static/media/bt_top_userselectkiroku_normal.57280e05.png";